<template>
    <main class="page page-dashboard">
        <div class="container">
            <PageHeader
                :title="$translate.text('general.register.step1')"
                v-if="step === 1"
            />

            <PageHeader
                :title="$translate.text('general.register.step2')"
                v-if="step === 2"
            />

            <!-- <p>{{ t('g') }} -->

            <form @submit.prevent="submitForm" style="padding-top:4px;">
                <div class="step-1" v-if="step === 1">
                    <h4>{{ t('general.company_information') }}</h4>

                    <TextInput
                        id="company"
                        :value="company"
                        name="company"
                        @change="company = $event"
                        :label="$translate.text('general.company.name')"
                    />

                    <TextInput
                        id="clientStreet"
                        :value="clientStreet"
                        name="clientStreet"
                        @change="clientStreet = $event"
                        :label="$translate.text('general.address.address')"
                    />

                    <TextInput
                        id="clientZipcode"
                        :value="clientZipcode"
                        name="clientZipcode"
                        @change="clientZipcode = $event"
                        :label="$translate.text('general.address.zipcode')"
                    />

                    <TextInput
                        id="clientCity"
                        :value="clientCity"
                        name="clientCity"
                        @change="clientCity = $event"
                        :label="$translate.text('general.address.city')"
                    />

                    <Select
                        id="countries"
                        :value="clientCountry"
                        name="countries"
                        @change="clientCountry = $event"
                        :options="countriesSelectValues"
                        :label="$translate.text('general.address.country')"
                        :required="true"
                    />

                    <Select
                        id="states"
                        :value="clientState"
                        name="states"
                        @change="clientState = $event"
                        :options="statesSelectedValues"
                        :label="$translate.text('general.address.state')"
                        :required="true"
                    />

                    <TextInput
                        id="clientPhone"
                        :value="clientPhone"
                        name="clientPhone"
                        @change="clientPhone = $event"
                        :label="$translate.text('general.company.phone')"
                    />

                    <TextInput
                        id="clientWebsite"
                        :value="clientWebsite"
                        name="clientWebsite"
                        @change="clientWebsite = $event"
                        :label="$translate.text('general.company.website')"
                    />

                    <h4>{{ t('general.extra_information') }}</h4>

                    <TextInput
                        id="clientKvk"
                        :value="clientKvk"
                        name="clientKvk"
                        @change="clientKvk = $event"
                        :label="$translate.text('general.company.chamber_of_commerce')"
                    />

                    <TextInput
                        id="clientBTW"
                        :value="clientBTW"
                        name="clientBTW"
                        @change="clientBTW = $event"
                        :label="$translate.text('general.company.vat_number')"
                    />

                    <div class="form-submit">
                        <div>
                        </div>
                        <button
                            type="button"
                            class="button button--rounded"
                            @click="nextStep()"
                        >
                            {{ t('general.next_step') }}
                        </button>
                    </div>
                </div>

                <div class="step-2" v-if="step === 2">
                    <h4>{{ t('general.contact_information') }}</h4>

                    <TextInput
                        id="clientContactFirstname"
                        :value="clientContactFirstName"
                        name="clientContactName"
                        @change="clientContactFirstName = $event"
                        :required="true"
                        :label="$translate.text('general.contact.firstname')"
                    />

                    <TextInput
                        id="clientContactMiddleName"
                        :value="clientContactMiddleName"
                        name="clientContactMiddleName"
                        @change="clientContactMiddleName = $event"
                        :label="$translate.text('general.contact.middlename')"
                    />

                    <TextInput
                        id="clientContactLastName"
                        :value="clientContactLastName"
                        name="clientContactLastName"
                        :required="true"
                        @change="clientContactLastName = $event"
                        :label="$translate.text('general.contact.lastname')"
                    />

                    <TextInput
                        id="clientContactNumber"
                        :value="clientContactNumber"
                        name="clientContactNumber"
                        @change="clientContactNumber = $event"
                        :label="$translate.text('general.company.phone')"
                    />

                    <EmailInput
                        id="email"
                        :value="email"
                        name="email"
                        :required="true"
                        @change="email = $event"
                        :label="$translate.text('general.email')"
                    />

                    <PasswordInput
                        id="password"
                        :value="password"
                        name="password"
                        @change="password = $event"
                        :required="true"
                        :label="$translate.text('general.password')"
                    />

                    <PasswordInput
                        id="passwordRepeat"
                        :value="password_confirmation"
                        name="passwordRepeat"
                        @change="password_confirmation = $event"
                        :label="$translate.text('general.password_confirm')"
                    />

<!--                    <Select-->
<!--                        id="language"-->
<!--                        :value="language"-->
<!--                        name="language"-->
<!--                        @change="language = $event"-->
<!--                        :options="options"-->
<!--                        :label="$translate.text('locales.preferred_language')"-->
<!--                    />-->

                    <div class="form-submit">
                        <div>
                            <a class="pointer" @click="step--" >{{ t('general.previous_step') }}</a>
                        </div>
                        <button
                            type="button"
                            class="button button--rounded"
                            @click="nextStep()"
                        >
                            {{ t('general.register') }}
                        </button>
                    </div>
                </div>

                <!-- <FormSubmit
                    :routeAfterCancelLink="{ name: 'Admin Resellers' }"
                    :buttonLabel="submittingIsLoading ? $translate.text('general.register') :  $translate.text('general.register')"
                    :disabled="submittingIsLoading"
                /> -->
            </form>
        </div>
    </main>
</template>
<script>
import swal from 'sweetalert';
import { post, get } from '@/helpers/http';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import EmailInput from '@/components/Inputs/EmailInput';
import Select from '@/components/Inputs/Select';
import PasswordInput from '@/components/Inputs/PasswordInput';
import SubscriptionPlan from '@/components/Subscription/SubscriptionPlan';

export default {
    name: 'Register',

    components: {
        PageHeader,
        TextInput,
        EmailInput,
        Select,
        PasswordInput,
        // SubscriptionPlan,
    },

    created() {
        this.getCountries();
    },

    data() {
        return {
            company: '',
            clientStreet: '',
            clientZipcode: '',
            clientCity: '',
            clientCountry: null,
            clientCountryId: null,
            clientState: null,
            clientPhone: '',
            clientWebsite: '',
            clientLogo: '',
            clientContactNumber: '',
            clientBTW: '',
            clientKvk: '',
            email: '',
            language: 'en_EN',
            password: '',
            password_confirmation: '',
            clientContactFirstName: '',
            clientContactMiddleName: '',
            clientContactLastName: '',
            options: [
                { label: this.$translate.text('locales.dutch'), value: 'nl_NL' },
                { label: this.$translate.text('locales.english'), value: 'en_EN' },
                { label: this.$translate.text('locales.german'), value: 'de_DE' },
            ],

            submittingIsLoading: false,

            step: 1,

            countries: [],
            countriesLoaded: false,

            states: [],
            statesLoaded: false,
        };
    },

    methods: {
        submitForm() {
            this.submittingIsLoading = true;

            post({
                url: `${this.$API_URL}/api/register`,
                data: {
                    company_name: this.company,
                    street: this.clientStreet,
                    zipcode: this.clientZipcode,
                    city: this.clientCity,
                    country: this.clientCountry,
                    state_id: this.clientState,
                    phonenumber: this.clientPhone,
                    website: this.clientWebsite,
                    logo_path: this.clientLogo,
                    contact_name: this.clientContactName,
                    contact_number: this.clientContactNumber,
                    btw: this.clientBTW,
                    kvk: this.clientKvk,
                    language: this.language,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    first_name: this.clientContactFirstName,
                    middle_name: this.clientContactMiddleName,
                    last_name: this.clientContactLastName,
                },
            })
                .then((response) => {
                    if (response.status === 201) {
                        swal(this.$translate.text('alert.success.message.register_client'));
                        this.$router.push('/login');
                    }
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        nextStep() {
            if (this.step === 1) {
                if (this.company === '') {
                    return swal(this.$translate.text('alert.whoops.message.company.required'));
                }
                // validation for step 1
            } else if (this.step === 2) {
                // validation for step 2
                if (this.language === '') {
                    return swal(this.$translate.text('alert.whoops.message.preferred_language.required'));
                }
                if (this.password.length >= 8) {
                    if (this.password === '' || (this.password !== this.password_confirmation)) {
                        return swal(this.$translate.text('alert.whoops.message.password_required'));
                    }
                } else {
                    return swal(this.$translate.text('wachtwoord moet minimaal 8 karakters zijn'));
                }


                if (this.clientContactFirstName === '') {
                    return swal(this.$translate.text('alert.whoops.message.firstname.required'));
                }

                if (this.clientContactLastName === '') {
                    return swal(this.$translate.text('alert.whoops.message.lastname.required'));
                }

                if (this.email === '') {
                    return swal(this.$translate.text('alert.whoops.message.email.required'));
                }

                if (!this.validateEmail(this.email)) {
                    return swal(this.$translate.text('alert.whoops.message.email.invalid'));
                }

                return this.submitForm();
            }

            this.step = this.step + 1;
        },

        getCountries() {
            get({
                url: `${this.$API_URL}/api/countries`,
            })
                .then((response) => {
                    this.countries = response.data.data;

                    this.clientCountry = this.countries[0].id;
                    this.countriesLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        changeActiveSub($event, option) {
            this.subscription.type = $event;
            this.subscription.id = option;
        },
    },

    computed: {
        statesSelectedValues() {
            if (this.clientCountry === '') {
                return [];
            }

            const values = [{ label: this.$translate.text('general.select_option'), value: null, disabled: true }];

            const country = this.countries.find(c => c.id == this.clientCountry);
            country.states.forEach(state => {
                values.push({
                    value: parseInt(state.id, 0),
                    label: state.name,
                });
            });

            return values;
        },
        countriesSelectValues() {
            const values = [{ label: this.$translate.text('general.select_option'), value: null, disabled: true }];

            this.countries.forEach(country => {
                values.push({
                    value: parseInt(country.id, 0),
                    label: country.name,
                });
            });

            return values;
        },

        clientContactName() {
            if (this.clientContactMiddleName) {
                return `${this.clientContactFirstName} ${this.clientContactMiddleName} ${this.clientContactLastName}`;
            }

            return `${this.clientContactFirstName} ${this.clientContactLastName}`;
        },
    },
};
</script>
<style lang="scss" scoped>

.form-submit {
    display: flex;
    align-items: center;

    div {
        flex: 2;

        a {
            color: $yellow;
            text-decoration: none;
            display: inline;
        }
    }

    button {
        flex: 6;
        width: 100%;
    }
}

.subscription {
    list-style: none;
    list-style-type: none;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 0;
}
</style>
